'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import PropTypes from 'prop-types';
import React from 'react';
import SVGTextStyle from './SVGTextStyle';
import SVGWrapper from './SVGWrapper';

var SVGText = function SVGText(props) {
  var wrapperProps = props.wrapperProps,
      innerProps = _objectWithoutProperties(props, ["wrapperProps"]);

  return React.createElement(SVGWrapper, wrapperProps, React.createElement(SVGTextStyle, innerProps));
};

SVGText.propTypes = {
  wrapperProps: PropTypes.any
};
export default SVGText;